import {createApp} from 'vue'
import CreateCancerForumProfile from './CreateCancerForumProfile'

const el = '.kb-component--create-cancer-forum-profile'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((CreateCancerForumProfileDOM) => {
            const component = createApp(CreateCancerForumProfile).use(Store)
            component.mount(CreateCancerForumProfileDOM)
        })
    }
}